import colors from "./palette.json";


export default {
	breakpoints: {
		values: {
			// xs-xl - MUI default breakpoints;
			xs: 0,
			sm: 600,
			ms: 750, // medium-small
			md: 900,
			ml: 1050, // medium-large
			lg: 1200,
			xl: 1536,

			// custom brakpoints
			dark: 500
		}
	},
	size: {
		header: {
			height: { in: 64, out: 96 }
		},
		footer: { height: 328 },
		sidebar: { width: 250 }
	},
	colors: {
		brand: colors.brand,
		external: colors.external
	},
	palette: {
		background: {
			white: colors.white,
			default: colors.grey["100"],
			paper: colors.white,
			header: "transparent",
			dark: "rgba(0, 0, 0, 0.08)"
		},
		text: {
			primary: colors.black,
			secondary: colors.grey["600"],
			light: colors.white,
			disabled: colors.grey["500"],
			label: colors.grey["600"],
			black: colors.black,
			coin: "#ffc451"
		},
		primary: {
			main: "rgba(32, 31, 32, 1)",
			dark: "rgba(32,31,32,.84)",
			light: "rgba(32,31,32,.54)",
			paper: "rgba(255, 255, 255, 0.85)",
			contrastText: colors.white
		},
		secondary: {
			main: "#464ba3",
			light: "#6b6fb5",
			dark: "#2c2e69",
			contrastText: colors.white
		},
		tertiary: {
			main: "#fc4e0f",
			light: "#fc713f",
			dark: "#b0360a",
			contrastText: colors.white
		},
		error: {
			main: "#ef5350",
			light: "#ef9a9a",
			dark: "#ce2c2c",
			contrastText: colors.white
		},
		success: {
			main: "#199f53",
			light: "#6cc68a",
			dark: "#007c38",
			contrastText: colors.white
		},
		coin: {
			main: "#ffc451",
			light: "rgb(255, 207, 115)",
			dark: "rgb(178, 137, 56)",
			contrastText: "rgba(0, 0, 0, 0.87)"
		},
		link: {
			main: "#ffa382",
			light: "rgb(255, 181, 155)",
			dark: "rgb(178, 114, 91)",
			contrastText: "rgba(0, 0, 0, 0.87)"
		},
		light: {
			main: colors.white,
			light: colors.white,
			dark: colors.grey["300"],
			contrastText: "rgba(0, 0, 0, 0.87)"
		},
		border: {
			default: colors.grey["200"],
			dark: colors.grey["400"],
			error: colors.red["200"],
			success: colors.green["400"],
			input: colors.grey["300"],
			focus: colors.green["300"]
		},
		accordion: {
			icon: colors.grey["500"]
		},
		modal: {
			text: {
				primary: colors.black,
				light: colors.white,
				dark: colors.black
			},
			close: {
				light: colors.grey["500"],
				dark: colors.white
			}
		},
		logo: {
			lite: "#464ba480"
		},
		alert: {
			error: {
				background: colors.red["100"],
				border: colors.red["600"],
				icon: colors.red["500"],
				text: colors.white
			}
		},
		pagination: {
			label: colors.grey["500"]
		},
		article: {
			skeleton: colors.grey["300"],
			shadow: "rgba(0, 0, 0, 0.36)"
		}
	},
	components: {
		MuiAlert: {
			variants: [
				{
					props: {
						variant: "error"
					},
					style: ({ theme }) => ({
						fontSize: "16px",
						fontWeight: 700,
						textAlign: "center",
						backgroundColor: "rgba(181,0,0,.41)",
						border: `2px solid ${theme.palette.error.main}`,
						borderRadius: "12px",
						width: "100%",
						color: colors.white,
						"&& .MuiAlert-icon": {
							color: theme.palette.error.main
						}
					})
				}
			]
		},
		MuiButton: {
			styleOverrides: {
				borderRadius: "12px",
				root: ({ theme }) => ({
					padding: theme.spacing(1.375, 2),
					textTransform: "unset",
					whiteSpace: "nowrap",
					borderRadius: "12px"
				})
			}
		},
		MuiChip: {
			variants: [
				{
					props: {
						variant: "coin"
					},
					style: ({ theme }) => ({
						fontFamily: "franklin-gothic-urw, sans-serif",
						fontSize: "12px",
						fontWeight: 700,
						backgroundColor: theme.palette.secondary.main,
						color: theme.palette.text.coin
					})
				}
			]
		},
		MuiInput: {
			styleOverrides: {
				root: {
					color: colors.grey["500"]
				}
			}
		},
		MuiCssBaseline: {
			styleOverrides: {
				"*": {
					boxSizing: "border-box"
				},
				body: { height: "100%" },
				root: { height: "100%" }
			}
		},
		MuiInputBase: {
			styleOverrides: {
				input: {
					color: "black !important"
				}
			}
		},
		MuiTypography: {
			defaultProps: {
				variantMapping: {
					body3: "p",
					body4: "p"
				}
			}
		}
	},
	typography: {
		fontFamily: "franklin-gothic-urw, sans-serif",
		fontStyle: "normal",
		lineHeight: "normal",
		htmlFontSize: 16,
		fontSize: 16,
		h1: {
			fontSize: "28px",
			fontWeight: 700,
			lineHeight: "normal"
		},
		h2: {
			fontSize: "24px",
			fontWeight: 700,
			lineHeight: "normal"
		},
		h3: {
			fontSize: "22px",
			fontWeight: 700,
			lineHeight: "normal"
		},
		h4: {
			fontSize: "20px",
			fontWeight: 700,
			lineHeight: "normal"
		},
		h5: {
			fontSize: "17px",
			fontWeight: 700,
			lineHeight: "normal"
		},
		h6: {
			fontSize: "16px",
			fontWeight: 700,
			lineHeight: "normal"
		},
		body1: {
			fontSize: "16px",
			fontWeight: 400,
			lineHeight: "normal"
		},
		body2: {
			fontSize: "15px",
			fontWeight: 400,
			lineHeight: "normal"
		},
		body3: {
			fontSize: "14px",
			fontWeight: 400,
			lineHeight: "normal"
		},
		body4: {
			fontSize: "12px",
			fontWeight: 400,
			lineHeight: "normal"
		},
		subtitle1: {
			fontSize: "11px",
			fontWeight: 700,
			lineHeight: "normal"
		},
		subtitle2: {
			fontSize: "11px",
			fontWeight: 400,
			lineHeight: "normal"
		},
		caption: {
			fontSize: "12px",
			fontWeight: 700,
			lineHeight: "normal"
		},
		overline: {
			fontSize: "10px",
			fontWeight: 400,
			lineHeight: "normal"
		},
		button: {
			fontSize: "17px",
			fontWeight: 700,
			lineHeight: "normal"
		}
	}
};